import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FirebaseApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { Input, Tag, Spin } from 'antd'
import { isMobile } from '../constants'
import {
  UserOutlined,
  MailOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'

type Props = { firebaseApp: FirebaseApp }

const UserData = (_: Props) => {
  const [userData, setUserData] = useState<any>(undefined)

  useEffect(() => {
    if (!userData) {
      const auth = getAuth()
      const user = auth.currentUser
      if (user !== null) {
        setUserData(user)
      }
    }
  }, [userData])

  if (!userData) {
    return (
      <Loading>
        <Spin tip="A Carregar..." size="large" />
      </Loading>
    )
  }

  return (
    <Container>
      <p>Nome:</p>
      <Input
        style={{
          marginBottom: isMobile ? '10px' : '20px',
          width: isMobile ? '80%' : '500px',
        }}
        size="middle"
        disabled
        prefix={<UserOutlined />}
        value={userData.displayName}
      />
      <p>Email:</p>
      <Input
        style={{
          marginBottom: isMobile ? '10px' : '20px',
          width: isMobile ? '80%' : '500px',
        }}
        size="middle"
        disabled
        prefix={<MailOutlined />}
        value={userData.email}
      />
      <p>
        Estado do Email:{' '}
        <Tag icon={<CheckCircleOutlined />} color="success">
          Verificado
        </Tag>
      </p>
    </Container>
  )
}

export default UserData

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100%;
  padding: 50px;

  @media (max-width: 768px) {
    padding: 5px;
  }
`
const Loading = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`
